import * as THREE from 'three';

export default class EdgeRenderer {

    constructor(scene, options = {}) {

        this.scene = scene;

        this.options = {

            color: 0x38bdf8,
            opacity: 0.18,
            maxEdges: 50000,

            ...options

        };

        this.positions = new Float32Array(
            this.options.maxEdges * 2 * 3
        );

        this.geometry = new THREE.BufferGeometry();

        this.geometry.setAttribute(

            'position',

            new THREE.BufferAttribute(
                this.positions,
                3
            )

        );

        this.geometry.setDrawRange(0, 0);

        this.material = new THREE.LineBasicMaterial({

            color: this.options.color,

            transparent: true,

            opacity: this.options.opacity,

            depthWrite: false

        });

        this.lines = new THREE.LineSegments(

            this.geometry,

            this.material

        );

        this.scene.add(this.lines);

    }

    update(edges) {

        let index = 0;

        const buffer = this.positions;

        for (const edge of edges) {

            if (index + 6 >= buffer.length)
                break;

            buffer[index++] = edge.from.x;
            buffer[index++] = edge.from.y;
            buffer[index++] = edge.from.z;

            buffer[index++] = edge.to.x;
            buffer[index++] = edge.to.y;
            buffer[index++] = edge.to.z;

        }

        this.geometry.setDrawRange(
            0,
            index / 3
        );

        this.geometry.attributes.position.needsUpdate = true;

    }

    clear() {

        this.geometry.setDrawRange(0, 0);

        this.geometry.attributes.position.needsUpdate = true;

    }

    setColor(color) {

        this.material.color.set(color);

    }

    setOpacity(opacity) {

        this.material.opacity = opacity;

    }

    dispose() {

        this.scene.remove(this.lines);

        this.geometry.dispose();

        this.material.dispose();

    }

}
